<seds-modal>
  <div header>{{ labels.userIdle.modal.expired.title }}</div>
  <div content>
    <p [innerHTML]="labels.userIdle.modal.expired.body"></p>
  </div>
  <div class="footer w-100 d-flex justify-content-end" footer>
    <seds-basic-button
      size="small"
      [title]="labels.userIdle.modal.expired.button.label"
      (click)="logout()"
    ></seds-basic-button>
  </div>
</seds-modal>
